import React, { useState, useEffect, useRef, useContext } from "react";
import { Tab, Row, Col, Nav } from "react-bootstrap";

import videoUrl from "../../video/howToObtainCoordinates.mp4";
import Select from "react-select";
import "./system-info.styles.scss";

import { GlobalContext } from "../../GlobalState";
import http from "../../api/http";

const SystemInfo = () => {
  const downloadRef = useRef(null);

  const [img, setImg] = useState("");
  const [imgOptions, setImgOptions] = useState([]);
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [isLoadingImage, setIsLoadingImage] = useState(false);

  const { selectedSchoolCode } = useContext(GlobalContext);

  const imageObjectUrlRef = useRef(null);

  const handleChangeImg = (selected) => {
    setImg(selected ? selected.value : "");
  };

  const revokeImageObjectUrl = () => {
    if (imageObjectUrlRef.current) {
      URL.revokeObjectURL(imageObjectUrlRef.current);
      imageObjectUrlRef.current = null;
    }
  };

  useEffect(() => {
    const loadOptions = async () => {
      try {
        const [floorsRes, areasRes] = await Promise.all([
          http.get(`floor/school/${selectedSchoolCode}`),
          http.get(`area/school/${selectedSchoolCode}`),
        ]);

        const allFloors = floorsRes.data.data.allFloorsBySchool || [];
        const allAreas = areasRes.data.data.allAreasBySchool || [];

        const allFloorOptions = allFloors.map((floor) => ({
          value: floor.img,
          label: floor.name,
        }));

        const allAreaOptions = allAreas.map((area) => ({
          value: area.img,
          label: area.name,
        }));

        const groupedOptions = [];

        if (allFloorOptions.length > 0) {
          groupedOptions.push({
            label: "Piso",
            options: allFloorOptions,
          });
        }

        if (allAreaOptions.length > 0) {
          groupedOptions.push({
            label: "Área",
            options: allAreaOptions,
          });
        }

        setImgOptions(groupedOptions);
      } catch (error) {
        console.error("Failed to load image options:", error);
        setImgOptions([]);
      }
    };

    if (selectedSchoolCode) {
      loadOptions();
    }
  }, [selectedSchoolCode]);

  useEffect(() => {
    const loadProtectedImage = async () => {
      if (!img || !selectedSchoolCode) {
        revokeImageObjectUrl();
        setImagePreviewUrl("");
        return;
      }

      try {
        setIsLoadingImage(true);

        const response = await http.get(`images/${selectedSchoolCode}/${img}`, {
          responseType: "blob",
        });

        revokeImageObjectUrl();

        const objectUrl = URL.createObjectURL(response.data);
        imageObjectUrlRef.current = objectUrl;
        setImagePreviewUrl(objectUrl);
      } catch (error) {
        console.error("Failed to load protected image:", error);
        revokeImageObjectUrl();
        setImagePreviewUrl("");
      } finally {
        setIsLoadingImage(false);
      }
    };

    loadProtectedImage();

    return () => {
      // do nothing here; cleanup handled by main unmount effect below
    };
  }, [img, selectedSchoolCode]);

  useEffect(() => {
    return () => {
      revokeImageObjectUrl();
    };
  }, []);

  const imgPreview = () => {
    if (!imagePreviewUrl) return null;

    return (
      <img
        src={imagePreviewUrl}
        alt="Pré-visualização"
        style={{ width: "20vh", marginTop: "10px" }}
      />
    );
  };

  return (
    <div
      style={{
        width: "100%",
        paddingLeft: "5%",
        paddingRight: "5%",
        marginTop: "1rem",
      }}
    >
      <h1>Informações do Sistema</h1>

      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Row>
          <Col sm={3}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="first">
                  Como obter as coordenadas de uma área específica na imagem.
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">
                  Fazer Download das Plantas
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>

          <Col sm={9}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <p>
                  O vídeo abaixo mostra como obter as coordenadas de uma área
                  específica de uma imagem. As coordenadas são necessárias para
                  criar áreas e espaços!
                </p>
                <video controls style={{ width: "50vw", height: "40vh" }}>
                  <source src={videoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </Tab.Pane>

              <Tab.Pane eventKey="second">
                <p>Selecione uma imagem para fazer o download.</p>

                <Select
                  placeholder="Selecione ou digite o nome de uma imagem"
                  options={imgOptions}
                  onChange={handleChangeImg}
                />

                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="systemInfo--downloadBtn"
                  ref={downloadRef}
                  href={imagePreviewUrl || ""}
                  download={img || ""}
                  title="FloorPlanImage"
                  style={{
                    pointerEvents: imagePreviewUrl ? "auto" : "none",
                    opacity: imagePreviewUrl ? 1 : 0.5,
                  }}
                >
                  Download
                </a>

                {isLoadingImage ? (
                  <p style={{ marginTop: "10px" }}>A carregar imagem...</p>
                ) : null}

                {imgPreview()}
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default SystemInfo;
